module.exports = __webpack_public_path__ + "static/media/tesselated.bb5080cf.mp3";